export type ColorPaletteV2Dark = {
  25: string;
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
};

type GradientColorPaletteV2Dark = {
  radiant: string;
};

const grayDarkV2: ColorPaletteV2Dark = {
  25: '#1c1f20',
  50: '#1e2021',
  100: '#212325',
  200: '#25292a',
  300: '#34383a',
  400: '#4a5464',
  500: '#5a6375',
  600: '#667085',
  700: '#98A2B3',
  800: '#D0D5DD',
  900: '#EAECF0',
};

const errorDarkV2: ColorPaletteV2Dark = {
  25: '#3b0c00',
  50: '#3d0904',
  100: '#4a0802',
  200: '#5a0702',
  300: '#790b02',
  400: '#9b1107',
  500: '#b8190e',
  600: '#F04438',
  700: '#F97066',
  800: '#FDA29B',
  900: '#FECDCA',
};

const seriousWarningDarkV2: ColorPaletteV2Dark = {
  25: '#3f1900',
  50: '#441a00',
  100: '#542200',
  200: '#6e3600',
  300: '#9d3700',
  400: '#c23700',
  500: '#dd3800',
  600: '#FF4405',
  700: '#FF692E',
  800: '#FF9C66',
  900: '#FFD6AE',
};

const regularWarningDarkV2: ColorPaletteV2Dark = {
  25: '#3f2c00',
  50: '#453400',
  100: '#5c4501',
  200: '#856201',
  300: '#af7a01',
  400: '#c98302',
  500: '#d97f07',
  600: '#F79009',
  700: '#FDB022',
  800: '#FEC84B',
  900: '#FEDF89',
};

const successDarkV2: ColorPaletteV2Dark = {
  25: '#073821',
  50: '#074027',
  100: '#09512d',
  200: '#0d6d42',
  300: '#169260',
  400: '#25b680',
  500: '#0fa15e',
  600: '#12B76A',
  700: '#32D583',
  800: '#6CE9A6',
  900: '#A6F4C5',
};

const greenDarkV2: ColorPaletteV2Dark = {
  25: '#073821',
  50: '#0a3d23',
  100: '#0c4d2c',
  200: '#136740',
  300: '#1d8b5c',
  400: '#2ead7a',
  500: '#149d58',
  600: '#16B364',
  700: '#3CCB7F',
  800: '#73E2A3',
  900: '#AAF0C4',
};

const tealDarkV2: ColorPaletteV2Dark = {
  25: '#07382f',
  50: '#083b2f',
  100: '#075646',
  200: '#0b7764',
  300: '#159b88',
  400: '#27b9a6',
  500: '#13a18b',
  600: '#15B79E',
  700: '#2ED3B7',
  800: '#5FE9D0',
  900: '#99F6E0',
};

const blueDarkV2: ColorPaletteV2Dark = {
  25: '#1e2021',
  50: '#202223',
  100: '#292c2e',
  200: '#333738',
  300: '#004e8a',
  400: '#025fa9',
  500: '#045fc1',
  600: '#2E90FA',
  700: '#53B1FD',
  800: '#84CAFF',
  900: '#B2DDFF',
};

const indigoDarkV2: ColorPaletteV2Dark = {
  25: '#1e2021',
  50: '#202223',
  100: '#242729',
  200: '#2c2f32',
  300: '#373b3f',
  400: '#07218a',
  500: '#0c1d9c',
  600: '#6172F3',
  700: '#8098F9',
  800: '#A4BCFD',
  900: '#C7D7FE',
};

const darkBlueDarkV2: ColorPaletteV2Dark = {
  25: '#1e2021',
  50: '#202223',
  100: '#292c2e',
  200: '#333738',
  300: '#002e8a',
  400: '#0038ab',
  500: '#0042c5',
  600: '#2970FF',
  700: '#528BFF',
  800: '#84ADFF',
  900: '#B2CCFF',
};

const violetDarkV2: ColorPaletteV2Dark = {
  25: '#1c1f20',
  50: '#1e2122',
  100: '#212425',
  200: '#282b2c',
  300: '#323638',
  400: '#220484',
  500: '#3408a2',
  600: '#875BF7',
  700: '#A48AFB',
  800: '#C3B5FD',
  900: '#DDD6FE',
};

const pinkDarkV2: ColorPaletteV2Dark = {
  25: '#380725',
  50: '#39092c',
  100: '#420832',
  200: '#55063d',
  300: '#6f074e',
  400: '#930963',
  500: '#ae0f7f',
  600: '#EE46BC',
  700: '#F670C7',
  800: '#FAA7E0',
  900: '#FCCEEE',
};

const orangeDarkV2: ColorPaletteV2Dark = {
  25: '#392206',
  50: '#402203',
  100: '#502a04',
  200: '#694208',
  300: '#8d4409',
  400: '#b04b0b',
  500: '#c74f0e',
  600: '#EF6820',
  700: '#F38744',
  800: '#F7B27A',
  900: '#F9DBAF',
};

const yellowDarkV2: ColorPaletteV2Dark = {
  25: '#3f3a04',
  50: '#453b03',
  100: '#5f5401',
  200: '#7d6b01',
  300: '#957802',
  400: '#d1a204',
  500: '#ce9607',
  600: '#EAAA08',
  700: '#FAC515',
  800: '#FDE272',
  900: '#FEEE95',
};

const gradientDarkV2: GradientColorPaletteV2Dark = {
  radiant: `linear-gradient(95.34deg, ${blueDarkV2[600]} 30.62%, ${pinkDarkV2[500]} 79.47%, ${yellowDarkV2[400]} 112.72%)`,
};

export const colorsV2Dark = {
  gray: grayDarkV2,
  error: errorDarkV2,
  seriousWarning: seriousWarningDarkV2,
  regularWarning: regularWarningDarkV2,
  success: successDarkV2,
  green: greenDarkV2,
  teal: tealDarkV2,
  blue: blueDarkV2,
  indigo: indigoDarkV2,
  darkBlue: darkBlueDarkV2,
  violet: violetDarkV2,
  pink: pinkDarkV2,
  orange: orangeDarkV2,
  yellow: yellowDarkV2,
  gradient: gradientDarkV2,
};

type ColorNameV2Dark = keyof typeof colorsV2Dark;

export type ColorV2Dark = {
  [K in ColorNameV2Dark]: K extends 'gradient'
    ? `${K}.${keyof GradientColorPaletteV2Dark}`
    : `${K}.${keyof ColorPaletteV2Dark}`;
}[keyof typeof colorsV2Dark];
